
<template>
    <v-row class="px-0">
        <v-col cols="12" md="12">
            <v-card-subtitle class="title px-0 mx-0">{{ $t('mainStore.personalize.disclaimers.title') }}</v-card-subtitle>
            <v-card-text class="grey--text px-0 mx-0">
                {{ $t('mainStore.personalize.disclaimers.subtitle') }}
            </v-card-text>
            <div class="d-flex align-strech">
                <v-card width="250" height="300" class="white lighten-3 mr-6 overflow-hidden"
                    v-for="disclaimer in documents" :key="disclaimer.id">
                    <div>
                        <div class="d-flex justify-space-between pa-1" style="position: absolute; z-index: 3; width: 100%">
                            <v-chip label color="success" v-if="disclaimer.status">{{ $t('common.active') }}</v-chip>
                            <v-chip label color="error" v-if="!disclaimer.status">{{ $t('common.inactive') }}</v-chip>
                            <div v-if="caducaEn(disclaimer)">
                                <v-chip label class="text-caption pa-3">{{ caducaEn(disclaimer) }}</v-chip>
                            </div>

                            <v-menu bottom left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-chip class="px-1" label v-bind="attrs" v-on="on" color="grey" outlined><v-icon
                                            color="black">mdi-dots-vertical</v-icon></v-chip>

                                </template>

                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title
                                            @click="edit(disclaimer)"><v-icon>mdi-pencil-outline</v-icon></v-list-item-title>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-title
                                            @click="remove(disclaimer)"><v-icon>mdi-trash-can-outline</v-icon></v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>

                        <v-card-title class="pt-9">
                            {{ disclaimer.title }}
                        </v-card-title>
                        <v-card-text>
                            <div v-html="disclaimer.text"></div>
                        </v-card-text>
                    </div>


                </v-card>


                <v-card elevation="0" width="250" min-height="120"
                    class="white lighten-3 mr-6 d-flex align-center justify-center" color="grey lighten-3" @click="add()">
                    <div>
                        <div class="d-flex justify-center">
                            <v-icon class="black--text mx-auto" x-large>mdi-plus-circle-outline</v-icon>
                        </div>
                        <v-card-title class="title text-center pb-0 mb-0">{{
                            $t('mainStore.personalize.disclaimers.addDisclaimer') }}</v-card-title>
                    </div>
                </v-card>
            </div>
        </v-col>
        <v-dialog v-model="show" width="768">
            <v-card class="mx-auto">
                <v-card-title
                    class="d-flex justify-space-between">{{ $t('mainStore.personalize.disclaimers.dialogTitle') }}<v-btn icon
                        color="grey" @click="cancel()"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
                <v-card-text>
                    <v-text-field v-model="form.title"
                        :label="$t('mainStore.personalize.disclaimers.disclaimerTitle')"></v-text-field>
                    <v-textarea v-model="form.text"
                        :label="$t('mainStore.personalize.disclaimers.disclaimerText')"></v-textarea>
                    <v-switch v-model="form.hasValidate"
                        :label="form.hasValidate ? $t('mainStore.personalize.disclaimers.expires') : $t('mainStore.personalize.disclaimers.noExpires')"></v-switch>
                    <v-menu v-if="form.hasValidate">
                        <template v-slot:activator="{ on, attrs }">

                            <v-text-field label="Fecha de vencimiento" readonly v-model="formatedDate" v-bind="attrs"
                                v-on="on" append-icon="mdi-calendar"></v-text-field>

                        </template>
                        <v-date-picker v-model="form.dueDate"></v-date-picker>
                    </v-menu>


                    <v-switch v-model="form.status"
                        :label="form.status ? $t('mainStore.personalize.disclaimers.active') : $t('mainStore.personalize.disclaimers.inactive')"></v-switch>

                </v-card-text>
                <v-card-actions class="d-flex justify-end pa-4">
                    <v-btn text @click="cancel()">{{ $t('mainStore.personalize.disclaimers.cancel') }}</v-btn>
                    <v-btn @click="save()" color="success" elevation="0"
                        :loading="processing">{{ $t('mainStore.personalize.disclaimers.save') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="toDelete" width="480">
            <v-card class="mx-auto">
                <v-card-title class="d-flex justify-space-between">{{$t('mainStore.personalize.disclaimers.deleteTitle')}}<v-btn icon color="grey"
                        @click="toDelete = false"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
                <v-card-subtitle></v-card-subtitle>
                <v-card-actions class="d-flex justify-end pa-4">
                    <v-btn text @click="toDelete = false">{{ $t('mainStore.personalize.disclaimers.cancel') }}</v-btn>
                    <v-btn @click="removeDisclaimer()" color="error" elevation="0">{{$t('common.remove')}}</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
        <v-snackbar style="top: 70px" top right color="info" :timeout="5000" v-model="removed">
            {{ $t('mainStore.personalize.disclaimers.snackMsgErr') }}

            <template v-slot:action="{ attrs }">
                <v-btn color="white" icon v-bind="attrs" @click="removed = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar style="top: 70px" top right color="green" :timeout="5000" v-model="saved">
            {{ $t('mainStore.personalize.disclaimers.snackMsgSucess') }}
            <template v-slot:action="{ attrs }">
                <v-btn color="red" icon v-bind="attrs" @click="saved = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-row>
</template>
<script>
import moment from 'moment'
import { mapState } from "vuex";

export default {
    name: "DisclaimersSection",
    components: {
    },
    data: () => ({
        processing: false,
        loading: true,
        toDelete: false,
        saved: false,
        removed: false,
        removeSnap: null,
        types: [{ text: 'Imagen', value: 'image' }, { text: 'Imagen y texto', value: 'text-image' }],
        show: false,
        form: {
            dueDate: null,
            hasValidate: false,
            status: true,
            store: null,
            text: "",
            id: "",
            title: ""
        },
        snap: {
            dueDate: null,
            hasValidate: false,
            status: true,
            store: null,
            text: "",
            id: "",
            title: ""
        },
    }),
    props: {
        documents: Array
    },
    watch: {
        'selectedStore': {
            deep: true,
            haldler() {
                this.load()
            }
        },
    },
    mounted() {

    },

    computed: {
        ...mapState("groupStores", [
            "selectedStore",
        ]),
        formatedDate() {
            if (!this.form.dueDate) return '-'
            return moment(this.form.dueDate, 'YYYY-MM-DD').format('LL')
        }
    },
    methods: {
        caducaEn(disclaimer) {
            if (disclaimer.hasValidate) {
                return moment(disclaimer.dueDate, 'YYYY-MM-DD').fromNow();
            }
            else {
                return null
            }
        },
        add() {
            this.show = true
        },
        cancel() {
            this.show = false
            this.form = JSON.parse(JSON.stringify(this.snap))

        },
        remove(item) {
            this.removeSnap = item
            this.toDelete = true
        },
        removeDisclaimer() {
            const snap = JSON.parse(JSON.stringify(this.documents))
            const index = snap.findIndex(object => {
                return object.id === this.removeSnap.id;
            });

            snap.splice(index, 1)

            this.toDelete = false
            //this.removed = true
            this.$emit('update-store', snap)
        },
        edit(disclaimer) {
            this.form = JSON.parse(JSON.stringify(disclaimer))
            this.show = true
        },


        save() {
            this.processing = true
            const Form = JSON.parse(JSON.stringify(this.form))
            let snap = JSON.parse(JSON.stringify(this.documents))
            if (this.form.id) {
                Form.updatedOn = moment().format()
                const index = snap.findIndex(object => {
                    return object.id === this.form.id;
                });
                snap[index] = Form
            }
            else {
                Form.createdOn = moment().format()
                Form.id = `dis${moment().format('X')}`
                snap.push(Form)
            }
            console.log('emiting...', snap)
            this.$emit('update-store', snap)

            this.show = false
            this.processing = false
            this.form = JSON.parse(JSON.stringify(this.snap))
            //this.saved = true
        },
    }

}
</script>